import Vue from 'vue';
import { ED_MODAL_EVENTS } from '@/plugins/ed-modal/ed-modal.plugin';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import { IActionModalConfirmation, IParamsModalConfirmation, IParamsModalConfirmationRadios } from '../../interfaces/params-modal-confirmation.interface';
import { IResponseConfirmationModal } from '../../interfaces/response-confirmation-modal.interface';

@Component({})
export default class EdModalConfirmation extends Vue {

  @Prop({}) readonly params: IParamsModalConfirmation;

  public isSecondProcessing: boolean = false;
  public isFirstProcessing: boolean = false;
  public optionSelected: boolean = false;
  public optionRadioValue: string = 'first';
  public inputValue: any = {
    valid: false,
    value: '',
    validators: {}
  }
  public actions: IActionModalConfirmation[] = [];

  get body(): string {
    return this.params.body;
  }

  get title(): string{
    return this.params.title ? this.params.title : String(this.$i18n.t('common.pleaseConfirm'));
  }

  get actionText(): string {
    return this.params.actionText ? this.params.actionText : String(this.$i18n.t('common.accept'));
  }

  get secondActionText(): string {
    return this.params.secondActionText ? this.params.secondActionText : String(this.$i18n.t('common.cancel'));
  }

  get hasThirdAction(): boolean {
    return this.params.thirdAction ? true : false;
  }

  get thirdActionText(): string {
    return this.params.thirdActionText || '';
  }

  get hasOptionCheck(): boolean {
    return this.params.hasOptionCheck;
  }

  get labelOption(): string {
    return this.params.labelOptionCheck;
  }

  get hasOptionRadio(): boolean {
    return this.params.hasOptionRadio ? true : false;
  }

  get firstOptionRadioText(): string {
    return this.params.firstOptionRadioText || '';
  }

  get secondOptionRadioText(): string {
    return this.params.secondOptionRadioText || '';
  }

  get responseModal(): IResponseConfirmationModal {
    return { 
      optionSelected: this.optionSelected,
      optionRadioValue: this.optionRadioValue,
      inputValue: this.inputValue.value 
    }
  }

  get hasInput() {
    return this.params.hasInput;
  }

  get inputLabel() {
    return this.params.inputLabel;
  }

  get secondActionRequiredInput() {
    return this.params.secondActionRequiredInput;
  }

  get radios(): IParamsModalConfirmationRadios[] {
    return this.params.radios || this.getRadiosItems();
  }

  public setResponse(action: Function, res: IResponseConfirmationModal) {
    setTimeout(() => { if(action) action(res); }, 0);
  }

  goToCloseModal() {
    if(this.params.closeAction) {
      this.params.closeAction();
    } else {
      this.$EdModal.$emit(ED_MODAL_EVENTS.ED_MODAL_CONFIRMATION_HIDE);
    }
  }

  goToAction(action: IActionModalConfirmation) {
    this.setResponse(action.action, this.responseModal);
    if(action.hasLoading) {
      Vue.set(action, 'isProcessing', true);
    } else {
      this.$EdModal.$emit(ED_MODAL_EVENTS.ED_MODAL_CONFIRMATION_HIDE);
    }
  }

  public setActions() {
    let actions: IActionModalConfirmation[] = [];
    if(!this.params.actions) {
      if(this.thirdActionText) {
        actions.push({
          label: this.thirdActionText,
          action: this.params.thirdAction,
          color: 'gray'
        });
      }
      if(this.secondActionText) {
        actions.push({
          hasLoading: this.params.secondLoadingIsDone,
          label: this.secondActionText,
          action: this.params.secondAction,
          mode: 'outline'
        });
      }
      if(this.actionText) {
        actions.push({
          hasLoading: this.params.firstLoadingIsDone,
          label: this.actionText,
          action: this.params.action,
        });
      }
    } else {
      actions = this.params.actions;
    }
    this.actions = actions;
  }

  created() {
    this.setActions();
  }

  private getRadiosItems(): IParamsModalConfirmationRadios[] {
    const radios: IParamsModalConfirmationRadios[] = [];
    if(this.firstOptionRadioText) {
      radios.push({
        name: 'first',
        label: this.firstOptionRadioText,
      });
    }
    if(this.secondOptionRadioText) {
      radios.push({
        name: 'second',
        label: this.secondOptionRadioText,
      });
    }
    return radios;
  }

}
